import styled from 'styled-components';

import ActionButton from 'components/action-button';
import { brandFont } from 'components/layout/brand-font';
import { BackArrowHistory as BackArrow } from 'components/navigation/back-arrow';

export const BackButtonContainer = styled.div`
  background-color: ${Styles.color.cardBackground};
  padding: 1rem 1rem 0;
`;

export const StyledBackButton = styled(ActionButton)`
  & > span {
    font: ${brandFont.copyTwo};
  }
`;

export const StyledBackArrow = styled(BackArrow)`
  top: calc(3px + env(safe-area-inset-top) - ${Styles.layout.navHeight.mobile});
`;
